import dynamic from 'next/dynamic';

export const Sidebar = dynamic(/* webpackChunkName: 'sidebar' */ import('./index'), {
    ssr: false
});
